// import ApiHelper from "../../ApiHelper";
// import API_ENDPOINTS from "../../endpoints";

// class CourseHelper {
//   // Course Category Methods
//   async getAllCategories(params = {}) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.LIST, params);
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to fetch course categories: ${error.message}`);
//     }
//   }

//   async getCategoryById(categoryId) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.GET, { id: categoryId });
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to fetch category by ID: ${error.message}`);
//     }
//   }

//   async createCategory(categoryData) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.CREATE, categoryData);
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to create course category: ${error.message}`);
//     }
//   }

//   async updateCategory(categoryId, updateData) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.UPDATE, {
//         id: categoryId,
//         ...updateData
//       });
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to update course category: ${error.message}`);
//     }
//   }

//   async deleteCategory(categoryId) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.DELETE, { id: categoryId });
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to delete course category: ${error.message}`);
//     }
//   }

//   // Course Methods
//   async getAllCourses(params = {}) {
//     try {
//       const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.COURSES.LIST, params);
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to fetch courses: ${error.message}`);
//     }
//   }

//   async getCourseById(courseId) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSES.GET, { id: courseId });
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to fetch course by ID: ${error.message}`);
//     }
//   }

//   async createCourse(courseData) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSES.CREATE, courseData);
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to create course: ${error.message}`);
//     }
//   }

//   async updateCourse(courseId, updateData) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSES.UPDATE, {
//         id: courseId,
//         ...updateData
//       });
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to update course: ${error.message}`);
//     }
//   }

//   async deleteCourse(courseId) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSES.DELETE, { id: courseId });
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to delete course: ${error.message}`);
//     }
//   }

//   // SME Assignment Methods
//   async assignSMEToCourse(courseId, smeId) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSES.ASSIGN_SME, {
//         courseId,
//         smeId
//       });
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to assign SME to course: ${error.message}`);
//     }
//   }

//   async unassignSMEFromCourse(courseId, smeId) {
//     try {
//       const response = await ApiHelper.delete(API_ENDPOINTS.ADMIN.COURSES.UNASSIGN_SME(courseId, smeId));
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to unassign SME from course: ${error.message}`);
//     }
//   }

//   async getCourseSMEs(courseId) {
//     try {
//       const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSES.GET_SMES, { courseId });
//       return response;
//     } catch (error) {
//       throw new Error(`Failed to fetch course SMEs: ${error.message}`);
//     }
//   }
// }

// export default new CourseHelper();

import ApiHelper from "../../ApiHelper";
import API_ENDPOINTS from "../../endpoints";

class CourseHelper {
  // Course Category Methods
  async getAllCategories(params = {}) {
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.LIST, params);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch course categories: ${error.message}`);
    }
  }

  async getCategoryById(categoryId) {
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.GET, { id: categoryId });
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch category by ID: ${error.message}`);
    }
  }

  async createCategory(categoryData) {
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.CREATE, categoryData);
      return response;
    } catch (error) {
      throw new Error(`Failed to create course category: ${error.message}`);
    }
  }

  async updateCategory(categoryId, updateData) {
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.UPDATE, {
        id: categoryId,
        ...updateData
      });
      return response;
    } catch (error) {
      throw new Error(`Failed to update course category: ${error.message}`);
    }
  }

  async deleteCategory(categoryId) {
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSE_CATEGORIES.DELETE, { id: categoryId });
      return response;
    } catch (error) {
      throw new Error(`Failed to delete course category: ${error.message}`);
    }
  }

  // Course Methods - Fixed endpoint usage
  async getAllCourses(params = {}) {
    try {
      // Convert params to query string if needed
      let queryString = '';
      if (Object.keys(params).length > 0) {
        const searchParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
          if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
            searchParams.append(key, params[key]);
          }
        });
        queryString = searchParams.toString();
      }
      
      // Use the direct endpoint string
      const baseUrl = '/admin/courses';
      const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
      const response = await ApiHelper.get(url);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch courses: ${error.message}`);
    }
  }

  async getCourseById(courseId) {
    try {
      const response = await ApiHelper.get(`/admin/courses/${courseId}`);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch course by ID: ${error.message}`);
    }
  }

  async createCourse(courseData) {
    try {
      const response = await ApiHelper.post('/admin/courses', courseData);
      return response;
    } catch (error) {
      throw new Error(`Failed to create course: ${error.message}`);
    }
  }

  async updateCourse(courseId, updateData) {
    try {
      const response = await ApiHelper.post(`/admin/courses/${courseId}`, updateData);
      return response;
    } catch (error) {
      throw new Error(`Failed to update course: ${error.message}`);
    }
  }

  async deleteCourse(courseId) {
    try {
      const response = await ApiHelper.delete(`/admin/courses/${courseId}`);
      return response;
    } catch (error) {
      throw new Error(`Failed to delete course: ${error.message}`);
    }
  }

  // SME Assignment Methods
  async assignSMEToCourse(courseId, smeId) {
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSES.ASSIGN_SME, {
        courseId,
        smeId
      });
      return response;
    } catch (error) {
      throw new Error(`Failed to assign SME to course: ${error.message}`);
    }
  }

  async unassignSMEFromCourse(courseId, smeId) {
    try {
      const response = await ApiHelper.delete(API_ENDPOINTS.ADMIN.COURSES.UNASSIGN_SME(courseId, smeId));
      return response;
    } catch (error) {
      throw new Error(`Failed to unassign SME from course: ${error.message}`);
    }
  }

  async getCourseSMEs(courseId) {
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.COURSES.GET_SMES, { courseId });
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch course SMEs: ${error.message}`);
    }
  }
}

export default new CourseHelper();